import { render, staticRenderFns } from "./Businessmembershipview.vue?vue&type=template&id=bbdb4c64&"
import script from "./Businessmembershipview.vue?vue&type=script&lang=js&"
export * from "./Businessmembershipview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports